import { create } from 'zustand';

const useLoaderStore = create((set) => ({
  loaderData: {
    display: false,
    message: ''
  },
  setLoaderData: ({ display, message }) => set((state) => ({
    loaderData: {
      ...state.loaderData, // Spread the existing state to avoid overwriting other properties
      display: display,
      message: message
    }
  })),
}));

export default useLoaderStore;